<template>
  <div class="horizontal-bar-chart-node">
    <ChartHeader
      :value="value"
      :display-chart="displayChart"
      @set-display-chart="setDisplayChart"
      @deletChart="$emit('deleteChart')"
    />
    <div class="horizontal-bar-chart-container">
      <svg v-show="displayChart" ref="chart" class="pigeondoc-chart horizontal-bar-chart"></svg>
      <HorizontalBarChartTable :value="value" v-show="!displayChart" />
    </div>
  </div>
</template>

<script>
import ChartHeader from '../ChartHeader/ChartHeader.vue';
import HorizontalBarChartTable from './HorizontalBarChartTable.vue';
import horizontalChartMixin from './horizontalChartMixin.js';

export default {
  name: 'HorizontalBarChart',
  mixins: [horizontalChartMixin],
  components: {
    ChartHeader,
    HorizontalBarChartTable,
  },
  data() {
    return {
      displayChart: true,
    };
  },
  methods: {
    setDisplayChart(value) {
      this.displayChart = value;
    },
  },
};
</script>

<style>
.horizontal-bar-chart-node {
  width: 100%;
  margin: 4rem 0;
}

.horizontal-bar-chart-container {
  margin: 0 5%;
}

.horizontal-bar-chart-container svg {
  width: 100%;
}
</style>
